import * as styles from './styles';
import type { FormProps } from './DrawerBody/DrawerBody';
import { ErrorMessage, FastField, useFormikContext } from 'formik';

import { CaptionError, EditableLabel, Heading2 } from '@cobliteam/base-components';

export const ChecklistDrawerTitle = () => {
  const { values, setFieldValue } = useFormikContext<FormProps>();

  return (
    <Heading2 className={styles.checklistDrawerTitle}>
      <FastField
        name='checklistName'
        onChange={(e: string) => setFieldValue('checklistName', e, true)}
        labelText={values.checklistName}
        iconClassName={styles.editIcon}
        className={styles.editableLabel}
        as={EditableLabel}
      />
      <ErrorMessage name='checklistName'>{(msg) => <CaptionError>{msg}</CaptionError>}</ErrorMessage>
    </Heading2>
  );
};

export default ChecklistDrawerTitle;
